import styled from '@emotion/styled';

// Overlap fade transition
export const ModalOverlayTransitionWrapper = styled.div`
  .fade-enter,
  .fade-exit-done {
    opacity: 0;
  }

  .fade-enter-active {
    opacity: 75%;
    z-index: 205;
    transition: opacity 500ms;
  }

  .fade-enter-done,
  .fade-exit {
    opacity: 75%;
    z-index: 205;
  }

  .fade-exit-active {
    opacity: 0;
    transition: opacity 500ms;
  }
`;
// .pop-* = Content immediately appears (default)
// .slide_from_left-* = Content slides in from the left
// .slide_from_right-* = Content slides in from the right
// Order of states = *-enter, *-enter-active, *-enter-done,
//                   *-exit, *-exit-active, *-exit-done, *-enter, ...
export const ModalContentTransitionWrapper = styled.div`
  .pop-enter,
  .pop-done {
    display: inline;
    top: 100%;

    @media (min-width: 62em) {
      top: 0;
      right: -50%;
    }
  }

  .pop-active {
    display: inline;
    top: 15%;

    @media (min-width: 62em) {
      top: 0;
      right: 0;
    }
  }

  .pop-enter-done,
  .pop-exit {
    display: inline;
    top: 15%;

    @media (min-width: 62em) {
      top: 0;
      right: 0;
    }
  }

  .pop-exit-active {
    display: inline;
    top: 100%;

    @media (min-width: 62em) {
      top: 0;
      right: -50%;
    }
  }

  .slide_from_left-enter,
  .slide_from_left-done {
    display: inline;
    top: 100%;

    @media (min-width: 62em) {
      top: 0;
      left: -50%;
    }
  }

  .slide_from_left-enter-active {
    display: inline;
    top: 15%;
    transition: top 500ms;

    @media (min-width: 62em) {
      top: 0;
      left: 0;
      transition: left 500ms;
    }
  }

  .slide_from_left-enter-done,
  .slide_from_left-exit {
    display: inline;
    top: 15%;

    @media (min-width: 62em) {
      top: 0;
      left: 0;
    }
  }

  .slide_from_left-exit-active {
    display: inline;
    top: 100%;
    transition: top 500ms;

    @media (min-width: 62em) {
      top: 0;
      left: -50%;
      transition: left 500ms;
    }
  }

  .slide_from_right-enter,
  .slide_from_right-done {
    display: inline;
    top: 100%;

    @media (min-width: 62em) {
      top: 0;
      right: -50%;
    }
  }

  .slide_from_right-enter-active {
    display: inline;
    top: 15%;
    transition: top 500ms;

    @media (min-width: 62em) {
      top: 0;
      right: 0;
      transition: right 500ms;
    }
  }

  .slide_from_right-enter-done,
  .slide_from_right-exit {
    display: inline;
    top: 15%;

    @media (min-width: 62em) {
      top: 0;
      right: 0;
    }
  }

  .slide_from_right-exit-active {
    display: inline;
    top: 100%;
    transition: top 500ms;

    @media (min-width: 62em) {
      top: 0;
      right: -50%;
      transition: right 500ms;
    }
  }
`;